import React from 'react';
import {
    quotaTypeNotesClassName,
    quotaTypeNotesThemeBlueClassName,
    quotaTypeNotesThemeGreenClassName
} from './quota-type-notes.style';
import { ThemeName } from '../../../types';
import Theme from '../../layout/theme/theme.component';

interface QuotaTypeNotesProps {
    countryCount: number,
    theme?: ThemeName
}

const QuotaTypeNotes: React.FC<QuotaTypeNotesProps> = ({
    countryCount,
    theme
}) => (
    <Theme
        className={ quotaTypeNotesClassName }
        name={ theme }
        blueClassName={ quotaTypeNotesThemeBlueClassName}
        greenClassName={ quotaTypeNotesThemeGreenClassName }>
        *Based on { countryCount } countr{ countryCount === 1 ? 'y' : 'ies' }
    </Theme>
);

export default QuotaTypeNotes;
